module.exports = __webpack_public_path__ + "img/1f2a579.jpeg";